import { useMemo } from 'react'
const apiKey = process.env.mapApiKey
export default function GoogleMapItem({ lat, lng, idGoogle, language }) {

  // const idGoogleRef = useRef(null);

  // useEffect(() => {
  //   if (idGoogleRef.current !== null) {
  //     const loader = new Loader({
  //       apiKey: process.env.mapApiKey,
  //       version: 'weekly',
  //       libraries: ["places"]
  //     });
  //     let map;
  //     loader.load().then(() => {
  //       if (idGoogleRef.current !== null) {
  //         map = new google.maps.Map(idGoogleRef.current, {
  //           center: { lat: lat, lng: lng },
  //           zoom: 12,
  //         });
  //         new google.maps.Marker({
  //           position: { lat: lat, lng: lng },
  //           map,
  //           title: language === "Turkish" ? "Ip Konum" : "Ip Location",
  //         });
  //       }
  //     });
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [lat, lng]);

  const map = useMemo(() => {
    if (!lat && !lng) {
      return <></>
    }
    return <iframe
      className="google-map"
      style={{ border: "0", height: "24rem" }}
      loading="lazy"
      allowFullScreen
      referrerPolicy="no-referrer-when-downgrade"
      src={`https://www.google.com/maps/embed/v1/view?key=${apiKey}&zoom=9&center=${lat},${lng}`}>
    </iframe>
  }, [lat, lng])


  return map
    // <div
    //   id={idGoogle}
    //   className="google-map"
    //   ref={idGoogleRef}
    // >
    // </div>
    
  
}
